const approveRequestedCase = async ({ token, docId }) => {
  try {
    const response = await fetch(
      `https://lvdmsup.nablasol.net/DMS/api/approve_dms_document?status=Approved&docId=${docId}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default approveRequestedCase;
